import NMenu from './NMenu';

export default NMenu